import { qs, qsa, add, contains } from "@fluorescent/dom";
import {
  FadeUpReveal,
  FadeUpSplitReveal,
  FadeScaleReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  slider: "[data-slider]",
  revealItems: ".animation-fade-up-split-reveal, .animation-fade-up-reveal",
  slideItems: ".featured-collection__slide",
};

export default node => {
  let observer = null;
  const sliderElement = qs(selectors.slider, node);
  const columns = parseInt(node.dataset.columns);
  const slideItems = qsa(selectors.slideItems, node);
  const headerRevealItems = qsa(selectors.revealItems, node);
  const headerReveals = [];
  const slideReveals = [];

  if (shouldAnimate(node)) {
    headerRevealItems.forEach(revealItem => {
      // check which type of reveal needs to be initialized
      if (contains(revealItem, "animation-fade-up-split-reveal")) {
        headerReveals.push(new FadeUpSplitReveal(revealItem));
      } else if (contains(revealItem, "animation-fade-up-reveal")) {
        headerReveals.push(new FadeUpReveal(revealItem));
      }
    });

    slideItems.forEach((item, i) => {
      if (i < columns) {
        const slideItemReveals = [];
        const image = qs(".product-item__media .image", item);
        if (image) {
          slideItemReveals.push(new FadeScaleReveal(image));
        }

        qsa(
          ".product-item__product-title, .product-item__price-wrapper, .product-item__badges",
          item
        ).forEach(revealItem => {
          slideItemReveals.push(new FadeUpReveal(revealItem));
        });

        slideReveals.push(slideItemReveals);
      } else {
        const slideAnimItems = qsa(
          ".product-item__media .image, .product-item__product-title, .product-item__price-wrapper, .product-item__badges",
          item
        );

        if (slideAnimItems) {
          add(slideAnimItems, "animation-initialized");
        }
      }
    });

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  sliderElement.style.opacity = 1;

  function isVisible() {
    let delay = 0;
    headerReveals.forEach(reveal => {
      reveal.play(delay);

      if (reveal.type === "FadeUpSplitReveal") {
        delay += reveal.lineCount * window.theme.animation.delay;
      } else {
        delay += window.theme.animation.delay;
      }
    });

    slideReveals.forEach(slide => {
      let slideDelay = delay;
      slide.forEach(reveal => {
        reveal.play(slideDelay);
        slideDelay += window.theme.animation.delay;
      });
      delay += window.theme.animation.delay;
    });

    setTimeout(() => {
      add(node, "animation--complete");
    }, (headerReveals.length + slideReveals.length) * window.theme.animation.duration);
  }

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
